import { createFileRoute } from "@tanstack/react-router";
import { TemplateKpisPage } from "@/features/harvest-operation-template/template-kpis-page";
import { trpc } from "@/hooks/trpc";

export const Route = createFileRoute(
  "/harvests/operation-templates/$template_id/kpis",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: draft } =
    trpc.harvest.operationTemplates.revisionGetDraftForTemplate.useQuery(
      template_id,
    );
  if (!draft) return null;
  return <TemplateKpisPage templateId={draft.id} />;
}
